const icons = {};

icons.readingContext = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="white" />
  <path d="M12 11.5C12.2761 11.5 12.5 11.7239 12.5 12H14C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12H11.5C11.5 11.7239 11.7239 11.5 12 11.5Z" fill="#1679F9" />
  <path d="M2 11.1666H3.11111V12.8333H2V11.1666Z" fill="#1679F9" />
  <path d="M2 11.1666H3.11111V12.8333H2V11.1666Z" fill="#1679F9" />
  <path d="M20.8889 11.1666H22V12.8333H20.8889V11.1666Z" fill="#1679F9" />
  <path d="M20.8889 11.1666H22V12.8333H20.8889V11.1666Z" fill="#1679F9" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7 15C8.65685 15 10 13.6569 10 12C10 10.3431 8.65685 9 7 9C5.34315 9 4 10.3431 4 12C4 13.6569 5.34315 15 7 15ZM7 16.5C9.48528 16.5 11.5 14.4853 11.5 12C11.5 9.51472 9.48528 7.5 7 7.5C4.51472 7.5 2.5 9.51472 2.5 12C2.5 14.4853 4.51472 16.5 7 16.5Z" fill="#1679F9" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9C15.3431 9 14 10.3431 14 12C14 13.6569 15.3431 15 17 15ZM17 16.5C19.4853 16.5 21.5 14.4853 21.5 12C21.5 9.51472 19.4853 7.5 17 7.5C14.5147 7.5 12.5 9.51472 12.5 12C12.5 14.4853 14.5147 16.5 17 16.5Z" fill="#1679F9" />
</svg>



export default icons;